import React, {Component} from 'react';

import EditAthleteProfile from 'shared_features/athlete_popup/edit_profile';
import CreateAthleteView from '../create_athlete';
import RosterLabels from './labels';
import GroupInviteLink from '../group_invite';
import RosterRow from './row';
import Spinner from 'shared_features/spinner';
import InviteButtonWithCopy from './InviteButtonWithCopy';

import styles from './styles.module.scss';

class View extends Component {

    // TODO: remove hack around using title to determine if i should fetch

    componentDidMount() {
        if (this.props.title) {
            this.props.fetchAthletes(this.props.groupId, this.props.teamId);
            this.props.fetchRosterSettings();
        }
    }

    componentDidUpdate(prevProps) {
        // If the title or group ID changed, fetch athletes
        if ((this.props.title && this.props.title !== prevProps.title) ||
            (this.props.groupId && this.props.groupId !== prevProps.groupId)) {
            this.props.fetchAthletes(this.props.groupId, this.props.teamId);
            
            // Also fetch invite links when group changes to update the copy icon state
            if (this.props.groupId) {
                this.props.fetchInviteLinks(this.props.groupId);
            }
        }
    }

    _renderEmpty() {
        const props = this.props;
        return (<div className={styles.emptyContainer}>
            <div className={styles.dashedContainer}>
                <h2 className={styles.subheader}>Upload your athletes</h2>
                <div className={styles.description}>Get your roster up and running with this quick guide</div>
                <iframe
                    src='https://www.youtube.com/embed/zB-Xw0qiYo8?rel=0&modestbranding=1'
                    className={styles.video}
                    frameBorder='0'
                    allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                    allowFullScreen
                    referrerPolicy="strict-origin-when-cross-origin"
                    title='Upload Athletes Tutorial'
                />
                <div className={styles.emptyButton} onClick={()=>props.createAthlete(props.organizationId, props.teamId, props.groupId)}>Create athlete</div>
                <div className={styles.or}>OR</div>
                <div className={styles.emptyButton} onClick={props.importAthletes.bind(this)}>Import CSV roster</div>
            </div>
        </div>);
    }

    _renderTable() {
        return (<ul className={styles.resultsContainer}>
            <RosterLabels />
            {this._renderAthletes()}
        </ul>);
    }

    _renderAthletes() {
        const props = this.props;
        if (props.isLoading) {
            return null;
        } else {
            return props.athleteIds.map(id => <RosterRow id={id} key={`/athletes/${id}`} />);
        }
    }

    _renderSpinner() {
        const props = this.props;
        if (!props.isLoading) {
            return null;
        }
        return <Spinner className={styles.spinner} />;
    }

    render() {
        const props = this.props;

        return (
            <div>
                <div className={styles.titleText}>{props.title}</div>
                <div className={styles.optionsContainer}>
                    <span className={styles.columnsButton} onClick={props.filterColumns.bind(this)}>
                        <svg width="16" height="20" viewBox="0 0 18 18" fill="#1976d2">
                            <path d="M4.5 2.5h1.5v13h-1.5z M8.5 2.5h1.5v13h-1.5z M12.5 2.5h1.5v13h-1.5z" />
                        </svg>
                        Columns
                    </span>
                    
                    <span className={styles.importButton} onClick={props.importAthletes.bind(this)}>
                        <svg width="14" height="18" viewBox="0 0 16 18" fill="#1976d2">
                            <path d="M8 1.5l-4 4.5h2.5v9h3v-9h2.5L8 1.5z" />
                        </svg>
                        Import
                    </span>
                    
                    <InviteButtonWithCopy
                        groupId={props.groupId}
                        teamId={props.teamId}
                        organizationId={props.organizationId}
                        organization={props.organization}
                        // Use the actual team and group names from props (retrieved directly from database)
                        teamName={props.teamName}
                        groupName={props.groupName}
                        onClick={(e, effectiveGroupId, teamId, teamName, groupName) => {
                            // Use the names passed from props to ensure accuracy
                            // This avoids issues when team or group names contain hyphens
                            props.showGroupInviteDialog(effectiveGroupId, teamId, props.teamName, props.groupName);
                        }}
                        copyGroupInviteLink={props.copyGroupInviteLink}
                        fetchInviteLinks={props.fetchInviteLinks}
                    />
                    
                    <span className={styles.createButton} onClick={()=>props.createAthlete(props.organizationId, props.teamId, props.groupId)}>
                        + New Athlete
                    </span>
                </div>
                <input type="text"
                    className={styles.search}
                    placeholder="Search by name..."
                    value={props.search}
                    onChange={(event)=>props.filterAthletes(event.target.value)}
                    autoFocus />
                {!props.isLoading && !props.hasAthletes ? this._renderEmpty() : this._renderTable()}
                {this._renderSpinner()}
                <CreateAthleteView />
                <EditAthleteProfile />
            </div>
        );
    }

}

export default View;
